import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d6e3396"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alarm-monitor-real"
};
const _hoisted_2 = {
  class: "app-container"
};
const _hoisted_3 = {
  class: "search-container"
};
const _hoisted_4 = {
  class: "search-left"
};
const _hoisted_5 = {
  class: "table-container-wrapper"
};
const _hoisted_6 = {
  class: "table-top-flex"
};
const _hoisted_7 = {
  class: "table-title"
};
const _hoisted_8 = {
  key: 0,
  class: "button-container"
};
const _hoisted_9 = {
  class: "exit-test-bar"
};
const _hoisted_10 = {
  class: "exit-test-tip"
};
const _hoisted_11 = {
  key: 0,
  class: "dialog-footer"
};
const _hoisted_12 = {
  class: "pdf-preview-container"
};
const _hoisted_13 = ["src"];
import { downloadFlie } from "@/utils";
import { reactive, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { testListPage, testUnitListPage, finishTestOne, startTestOne, finishTest, exitTest, updateTestTask, getTestTaskInfo, getEnabledTestProcess } from "@/api/deviceManage";
import { ElMessage, ElMessageBox } from "element-plus";
import { CircleClose } from '@element-plus/icons-vue';
import { weChatrequest } from '@/utils/request';
const __default__ = {
  name: "alarm-monitor-real"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '测试管理';
    });
    const editFormRef = ref(null);
    const state = reactive({
      dialogVisible: false,
      isExport: false,
      tableData: {
        rows: [],
        total: 0
      },
      tableData1: {
        rows: [],
        total: 0
      },
      buttonsList: [
        // {
        //   buttonName: "停止全部测试",
        //   buttonStyle: "primary",
        //   className: 'stopAllTestBtn',
        //   buttonIcon: "VideoPause",
        //   hasPermi: ["device:page:stopTest"],
        //   exp: () => handleStopAll(),
        //   loadingHandle() {
        //     return state.stopAllTestLoading
        //   }
        // }
      ],
      // 退出测试相关
      exitTestLoading: false,
      selectedActuatorList: [],
      // 详情表格中选中的执行器列表
      // 停止全部测试相关
      stopAllTestLoading: false,
      // 编辑测试任务相关
      editDialogVisible: false,
      editLoading: false,
      testStatus: false,
      currentTestId: null,
      processList: [],
      processListLoading: false,
      editForm: {
        id: 0,
        taskName: '',
        planStartTime: '',
        planEndTime: '',
        intervalMinutes: 30,
        processId: 0,
        actuatorIds: [],
        remark: ''
      },
      editRules: {
        taskName: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }],
        processId: [{
          required: true,
          message: '请选择测试流程',
          trigger: 'change'
        }],
        planStartTime: [{
          required: true,
          message: '请选择计划开始时间',
          trigger: 'change'
        }],
        planEndTime: [{
          required: true,
          message: '请选择计划结束时间',
          trigger: 'change'
        }]
      },
      // 检测报告预览相关
      reportDialogVisible: false,
      currentPdfUrl: ''
    });
    let queryParams = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      endTime: "",
      startTime: "",
      dateRange: [],
      testStatus: ""
    });
    let queryParams1 = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      testId: ""
    });
    const handleStart = row => {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认开始测试?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        state.testLoading1 = true;
        return startTestOne(row.id);
      }).then(res => {
        state.testLoading = false;
        if (res.code == 0) {
          ElMessage.success("开始测试");
          getList();
        } else {
          ElMessage.error(res.msg || "开始测试失败");
        }
      }).catch(function () {
        state.testLoading1 = false;
      });
    };
    const handleStop = row => {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认停止测试?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        state.testLoading1 = true;
        return finishTestOne(row.id);
      }).then(res => {
        state.testLoading = false;
        if (res.code == 0) {
          ElMessage.success("停止测试");
          getList();
        } else {
          ElMessage.error(res.msg || "停止测试失败");
        }
      }).catch(function () {
        state.testLoading1 = false;
      });
    };

    // 停止全部测试
    const handleStopAll = () => {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认停止全部测试?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        state.stopAllTestLoading = true;
        return finishTest();
      }).then(res => {
        state.stopAllTestLoading = false;
        if (res.code == 0) {
          ElMessage.success("停止全部测试");
          // 刷新列表
          getList();
        } else {
          ElMessage.error(res.msg || "停止全部测试失败");
        }
      }).catch(function () {
        state.stopAllTestLoading = false;
      });
    };
    const searchFormData = ref([{
      prop: "testStatus",
      label: "测试状态",
      placeholder: "请选择测试状态",
      filterable: true,
      type: "list",
      isSelect: false,
      options: [{
        dictValue: 0,
        dictLabel: "待开始"
      }, {
        dictValue: 1,
        dictLabel: "测试中"
      }, {
        dictValue: 2,
        dictLabel: "已完成"
      }, {
        dictValue: 3,
        dictLabel: "已取消"
      }, {
        dictValue: 4,
        dictLabel: "异常中断"
      }],
      props: {
        label: "dictLabel",
        value: "dictValue"
      },
      span: 24
    }, {
      prop: "dateRange",
      type: "datetimerange",
      label: "测试时间",
      span: 2,
      change: val => {
        if (!val) {
          queryParams.startTime = "";
          queryParams.endTime = "";
        } else {
          queryParams.startTime = val[0];
          queryParams.endTime = val[1];
        }
      }
    }]);
    let loading = ref(false);
    let loading1 = ref(false);
    const getList = () => {
      loading.value = true;
      let params = {
        ...queryParams
      };
      delete params.dateRange;
      testListPage(params).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const getList1 = () => {
      loading1.value = true;
      testUnitListPage(queryParams1).then(res => {
        if (res.code == 0) {
          state.tableData1.rows = res.data.records;
          state.tableData1.total = res.data.total;
        }
      }).finally(() => {
        loading1.value = false;
      });
    };
    const resetQuery = () => {
      queryParams.pageNum = 1;
      queryParams.pageSize = 10;
      queryParams.endTime = "";
      queryParams.startTime = "";
      queryParams.dateRange = [];
      queryParams.testStatus = "";
      getList();
    };
    const closeOperate = function () {
      state.dialogVisible = false;
      state.selectedActuatorList = []; // 重置选中的执行器
    };
    const formatCode1 = function (code, column) {
      // 0-待开始，1-测试中，2-已完成，3-已取消，4-异常中断 
      if (code == 0) {
        return '待开始';
      } else if (code == 1) {
        return '测试中';
      } else if (code == 2) {
        return '已完成';
      } else if (code == 3) {
        return '已取消';
      } else if (code == 4) {
        return '异常中断';
      }
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      icon: "el-icon-search",
      class: "btn-liquid",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader1 = [{
      prop: "actNum",
      label: "执行器编号",
      fixed: false,
      minWidth: 130,
      type: "text"
    }, {
      prop: "testStatus",
      label: "测试状态",
      fixed: false,
      formatData: formatCode1,
      type: function (row) {
        // 0-待开始，1-测试中，2-已完成，3-已取消，4-异常中断
        if (row.testStatus == 0 || row.testStatus == 3) {
          return 'info';
        } else if (row.testStatus == 1) {
          return 'warning';
        } else if (row.testStatus == 2) {
          return 'success';
        } else if (row.testStatus == 4) {
          return 'error';
        }
      }
    }, {
      prop: "testResultDesc",
      label: "测试结果",
      fixed: false,
      type: "text"
    }, {
      prop: "startTime",
      label: "执行器开始测试时间",
      fixed: false,
      minWidth: 150,
      type: "text"
    }, {
      prop: "endTime",
      label: "执行器退出测试时间",
      minWidth: 150,
      fixed: false,
      type: "text"
    }, {
      prop: "operation",
      label: "操作",
      width: "100px",
      fixed: 'right',
      operation: [{
        name: '检测报告',
        clickFun: row => handlePreviewReport(row),
        hasPermi: ['testDevice:page:viewReport'],
        hideHandle: row => !row.pdfPath
      }, {
        name: '导出',
        clickFun: row => handleExport(row),
        hasPermi: []
      }]
    }];
    const tableHeader = [{
      prop: "index",
      label: "序号",
      fixed: false,
      type: "text"
    }, {
      prop: "taskName",
      label: "测试名称"
    }, {
      prop: "testStatus",
      label: "测试状态",
      fixed: false,
      formatData: formatCode1,
      type: function (row) {
        if (row.testStatus == 0 || row.testStatus == 3) {
          return 'info';
        } else if (row.testStatus == 1) {
          return 'warning';
        } else if (row.testStatus == 2) {
          return 'success';
        } else if (row.testStatus == 4) {
          return 'error';
        }
      }
    }, {
      prop: "testResultDesc",
      label: "测试结果",
      fixed: false,
      type: "text"
    }, {
      prop: "startTime",
      label: "测试开始时间",
      fixed: false,
      type: "text",
      minWidth: 120
    }, {
      prop: "endTime",
      label: "测试结束时间",
      fixed: false,
      type: "text",
      minWidth: 120
    }, {
      prop: "planStartTime",
      label: "计划开始时间 ",
      minWidth: 120
    }, {
      prop: "planEndTime",
      label: "计划结束时间 ",
      minWidth: 120
    }, {
      prop: "remark",
      label: "备注 "
    }, {
      prop: "operation",
      label: "操作",
      width: "320px",
      fixed: 'right',
      operation: [{
        name: '详情',
        clickFun: row => handleDetail(row),
        hasPermi: []
      }, {
        name: '停止测试',
        clickFun: row => handleStop(row),
        hasPermi: ["testRecord:page:stopTest"],
        disabledHandle(row) {
          // 只有测试中状态(testStatus == 1)才能点击停止测试
          return row.testStatus != 1;
        }
      }, {
        name: '开始测试',
        clickFun: row => handleStart(row),
        hasPermi: ["testRecord:page:stopTest"],
        disabledHandle(row) {
          // 只有待开始状态(testStatus == 0)才能点击开始测试
          return row.testStatus != 0;
        }
      }, {
        name: '编辑',
        clickFun: row => handleEditTestTask(row),
        hasPermi: ["testRecord:page:edit"]
        // disabledHandle(row) {
        //   // 只有待开始状态(testStatus == 0)才能编辑
        //   return row.testStatus != 0;
        // },
      }, {
        name: '放行',
        clickFun: row => handleForcePass(row),
        hasPermi: ["testRecord:page:go"],
        disabledHandle(row) {
          const isCancelled = row.testStatus == 3;
          const isFinishedFailed = row.testStatus == 2 && row.testResultDesc && row.testResultDesc.includes('不合格');
          return !isCancelled && !isFinishedFailed;
        }
      }]
    }];
    const handleDetail = row => {
      state.dialogVisible = true;
      queryParams1.testId = row.id;
      state.selectedActuatorList = []; // 重置选中的执行器
      getList1();
    };

    // 控制复选框是否可选
    const handleSelectable = (row, index) => {
      // 只有待开始(testStatus == 0)和测试中(testStatus == 1)的执行器可以退出测试
      // 并且 exitTime 不存在（还未退出过）
      return !row.exitTime && (row.testStatus == 0 || row.testStatus == 1);
    };
    const MAX_EXIT_COUNT = 20;

    // 表格选择变化
    const handleSelectionChange = selection => {
      if (selection.length > MAX_EXIT_COUNT) {
        ElMessage.closeAll();
        ElMessage.warning(`一次最多只能勾选 ${MAX_EXIT_COUNT} 个设备，超出部分已自动取消`);
        // 保留前 MAX_EXIT_COUNT 个，取消多余的
        state.selectedActuatorList = selection.slice(0, MAX_EXIT_COUNT);
        return;
      }
      state.selectedActuatorList = selection;
    };

    // 退出测试
    const handleExitTest = () => {
      ElMessage.closeAll();
      if (!queryParams1.testId) {
        ElMessage.warning("请先选择测试任务！");
        return;
      }

      // 检查是否有选中的执行器
      if (!state.selectedActuatorList || state.selectedActuatorList.length === 0) {
        ElMessage.warning("请至少选择一个执行器！");
        return;
      }

      // 显示确认对话框
      ElMessageBox.confirm(`是否确认退出选中的 ${state.selectedActuatorList.length} 个执行器？`, "退出测试", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 获取选中的执行器ID列表
        const exitIds = state.selectedActuatorList.map(item => item.actId || item.id);
        state.exitTestLoading = true;
        exitTest({
          actuatorIds: exitIds,
          testId: queryParams1.testId
        }).then(res => {
          state.exitTestLoading = false;
          if (res.code == 0) {
            ElMessage.success("退出测试成功");
            state.selectedActuatorList = [];
            getList1();
            getList();
          } else {
            ElMessage.error(res.message || "退出测试失败");
          }
        }).catch(() => {
          state.exitTestLoading = false;
        });
      }).catch(() => {
        // 取消操作
      });
    };

    /** 导出文件 */
    const handleExport = function (row) {
      downloadFlie('/ty-iot-manage/api/v1/actuator/testUnit/exportTestRecord/' + row.id);
    };

    /** 预览检测报告 */
    const handlePreviewReport = row => {
      if (!row.pdfPath) {
        ElMessage.warning('暂无检测报告');
        return;
      }
      // 设置当前PDF URL并打开弹窗
      state.currentPdfUrl = window.g.pdfUrlPrex + row.pdfPath;
      state.reportDialogVisible = true;
    };
    const loadProcessList = () => {
      state.processListLoading = true;
      getEnabledTestProcess().then(res => {
        state.processList = res.data || [];
        state.processListLoading = false;
      }).catch(() => {
        state.processListLoading = false;
      });
    };

    // 编辑测试任务 - 打开对话框
    const handleEditTestTask = async row => {
      try {
        state.testStatus = row.testStatus;
        state.editLoading = true;
        loadProcessList();
        // 获取测试任务详情
        const response = await getTestTaskInfo(row.id);
        if (response.code == 0 && response.data) {
          const data = response.data;
          state.currentTestId = data.id;
          state.editForm = {
            id: data.id || 0,
            taskName: data.taskName || '',
            planStartTime: data.planStartTime || '',
            planEndTime: data.planEndTime || '',
            intervalMinutes: data.intervalMinutes || 30,
            processId: data.processId || 0,
            actuatorIds: data.actuators?.map(a => a.id) || [],
            remark: data.remark || ''
          };
          state.editDialogVisible = true;
          setTimeout(() => {
            if (editFormRef.value) {
              editFormRef.value.clearValidate();
            }
          }, 100);
        } else {
          ElMessage.error(response.msg || '获取测试任务详情失败');
        }
      } catch (error) {
        console.error('获取测试任务详情失败:', error);
        ElMessage.error('获取测试任务详情失败');
      } finally {
        state.editLoading = false;
      }
    };

    // 禁用过去的日期（不包括今天）
    const disabledDate = time => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return time.getTime() < today.getTime();
    };

    // 禁用计划开始时间的过去日期
    const disabledStartTime = time => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return time.getTime() < today.getTime();
    };

    // 提交编辑测试任务
    const handleUpdateTestTask = () => {
      ElMessage.closeAll();
      if (!editFormRef.value) return;
      editFormRef.value.validate(valid => {
        if (!valid) return;

        // 验证计划开始时间是否为未来时间
        const startTime = new Date(state.editForm.planStartTime);
        const now = new Date();
        if (startTime.getTime() <= now.getTime()) {
          ElMessage.warning("计划开始时间必须选择未来的时间");
          return;
        }

        // 验证计划结束时间是否大于开始时间
        const endTime = new Date(state.editForm.planEndTime);
        if (endTime.getTime() <= startTime.getTime()) {
          ElMessage.warning("计划结束时间必须大于计划开始时间");
          return;
        }
        state.editLoading = true;
        updateTestTask({
          id: state.editForm.id,
          taskName: state.editForm.taskName,
          planStartTime: state.editForm.planStartTime,
          planEndTime: state.editForm.planEndTime,
          intervalMinutes: state.editForm.intervalMinutes,
          processId: state.editForm.processId,
          actuatorIds: state.editForm.actuatorIds,
          remark: state.editForm.remark
        }).then(res => {
          state.editLoading = false;
          if (res.code == 0) {
            ElMessage.success("编辑测试任务成功");
            state.editDialogVisible = false;
            state.currentTestId = null;
            state.editForm = {
              id: 0,
              taskName: '',
              planStartTime: '',
              planEndTime: '',
              intervalMinutes: 30,
              processId: 0,
              actuatorIds: [],
              remark: ''
            };
            getList(); // 刷新列表
          } else {
            ElMessage.error(res.msg || "编辑测试任务失败");
          }
        }).catch(() => {
          state.editLoading = false;
        });
      });
    };
    const handleForcePass = row => {
      ElMessageBox.close();
      ElMessageBox.confirm('确定要放行此测试任务吗？放行后将标记为测试通过。', "放行确认", {
        confirmButtonText: "确定放行",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return weChatrequest({
          url: `/api/v1/actuator/testTask/${row.id}/force-pass`,
          method: "put"
        });
      }).then(res => {
        if (res.code == 0) {
          ElMessage.success("放行成功");
          getList();
        } else {
          ElMessage.error(res.msg || "放行失败");
        }
      }).catch(function () {});
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_Iconfont, {
        name: "zhihui-ceshijilu",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          icon: item.buttonIcon,
          loading: item.loadingHandle?.(item.prop, _ctx.form),
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, _ctx.form),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "icon", "loading", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasSelect: false,
        tableData: state.tableData,
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])])]), _createVNode(_component_commonDrawer, {
        title: "测试记录详情",
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.dialogVisible = $event),
        size: "800px",
        "close-on-click-modal": false,
        "before-close": closeOperate
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, [_createTextVNode("（最多可勾选 20 个设备，当前已选 "), _createElementVNode("b", null, _toDisplayString(state.selectedActuatorList.length), 1), _createTextVNode(" 个）")]), _createVNode(_component_el_button, {
          type: "danger",
          class: "exit-test-btn",
          onClick: handleExitTest,
          loading: state.exitTestLoading
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "4px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(CircleClose))]),
            _: 1
          }), _createTextVNode("退出测试 ")]),
          _: 1
        }, 8, ["loading"])]), _withDirectives(_createVNode(_component_commonTable, {
          size: "medium",
          class: "detailTable",
          ref: "tableContainer",
          style: {
            "clear": "both"
          },
          hasStripe: false,
          hasSelect: true,
          firstMount: false,
          tableData: state.tableData1,
          tableHeader: tableHeader1,
          queryParams: _unref(queryParams1),
          onGetList: getList1,
          multipleSelection: state.selectedActuatorList,
          "onUpdate:multipleSelection": _cache[1] || (_cache[1] = $event => state.selectedActuatorList = $event),
          onSelectionChange: handleSelectionChange,
          selectable: handleSelectable
        }, null, 8, ["tableData", "queryParams", "multipleSelection"]), [[_directive_loading, _unref(loading1)]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        modelValue: state.editDialogVisible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.editDialogVisible = $event),
        title: "编辑测试任务",
        size: "600px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [state.testStatus == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => state.editDialogVisible = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: state.editLoading,
          onClick: handleUpdateTestTask
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.editForm,
          rules: state.editRules,
          ref_key: "editFormRef",
          ref: editFormRef,
          "label-width": "120px",
          "label-position": "top",
          class: "edit-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "任务名称",
            prop: "taskName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: state.editForm.taskName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.editForm.taskName = $event),
              placeholder: "请输入任务名称",
              maxlength: "50",
              "show-word-limit": "",
              disabled: state.testStatus != 0
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试流程名称",
            prop: "processId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: state.editForm.processId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.editForm.processId = $event),
              placeholder: "请选择测试流程",
              filterable: "",
              style: {
                "width": "100%"
              },
              loading: state.processListLoading,
              disabled: state.testStatus != 0
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.processList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.processName,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "loading", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "计划开始时间",
            prop: "planStartTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: state.editForm.planStartTime,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => state.editForm.planStartTime = $event),
              type: "datetime",
              placeholder: "请选择计划开始时间",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              style: {
                "width": "100%"
              },
              "disabled-date": disabledStartTime,
              disabled: state.testStatus != 0
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "计划结束时间",
            prop: "planEndTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: state.editForm.planEndTime,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => state.editForm.planEndTime = $event),
              type: "datetime",
              placeholder: "请选择计划结束时间",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              style: {
                "width": "100%"
              },
              "disabled-date": disabledDate,
              disabled: state.testStatus != 0
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试频率（分钟）",
            prop: "intervalMinutes"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: state.editForm.intervalMinutes,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.editForm.intervalMinutes = $event),
              min: 5,
              max: 1440,
              placeholder: "请输入测试频率",
              disabled: state.testStatus != 0,
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: state.editForm.remark,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => state.editForm.remark = $event),
              type: "textarea",
              rows: 3,
              placeholder: "请输入备注",
              maxlength: "500",
              disabled: state.testStatus != 0,
              "show-word-limit": ""
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: state.reportDialogVisible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => state.reportDialogVisible = $event),
        title: "检测报告预览",
        size: "900px",
        "close-on-click-modal": true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("iframe", {
          src: state.currentPdfUrl,
          frameborder: "0",
          class: "pdf-iframe"
        }, null, 8, _hoisted_13)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});